module.exports = __webpack_public_path__ + "img/bg-symptom5.bceafe84.png";